module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'hide-global-menu': _vm.activeCategory != '', 'menu-open': _vm.showModal
    },
    attrs: {
      "id": "app"
    }
  }, [_c('hero', {
    staticClass: "home-hero",
    attrs: {
      "content": _vm.heroContent
    },
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('voters', {
    staticClass: "voters col-xs-12 col-md-6 hideme"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('critic-quote', {
    staticClass: "hideme col-xs-12 no-pad",
    attrs: {
      "id": "homeProdQuote1",
      "criticSliderContent": _vm.criticQuote1
    }
  })], 1), _vm._v(" "), _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "modaltype": _vm.modalType,
      "categories": _vm.categories
    },
    on: {
      "clicked": _vm.categoryClicked,
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('categories', {
    attrs: {
      "categories": _vm.categories
    },
    on: {
      "clicked": _vm.categoryClicked
    }
  }), _vm._v(" "), _c('click-thru', {
    attrs: {
      "clickThru": _vm.clickThru
    },
    on: {
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('social'), _vm._v(" "), _c('legal'), _vm._v(" "), _c('category-pages', {
    attrs: {
      "id": "categoryPages",
      "categories": _vm.categories,
      "activeCategory": _vm.activeCategory,
      "previousCategory": _vm.previousCategory
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('back-to-top'), _vm._v(" "), _c('header', {
    attrs: {
      "id": "stickyHeader"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "laurels col-xs-12 col-md-6 hideme"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/awards-tout.jpg"),
      "alt": "Awards Tout",
      "width": "100%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3b0572","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Main.vue
// module id = 233
// module chunks = 0